const KEY = 'loudest_purchase_session';
const SESSION_RE = /^cs_(?:test|live)_[A-Za-z0-9]+$/;
export function isPurchaseSession(value) {
  return typeof value === 'string' && value.length <= 200 && SESSION_RE.test(value);
}

export function readPurchaseSession(storage) {
  try {
    const value = storage.getItem(KEY);
    return isPurchaseSession(value) ? value : '';
  } catch {
    return '';
  }
}

export function rememberPurchaseSession(storage, sessionId) {
  if (!isPurchaseSession(sessionId)) return false;
  try {
    storage.setItem(KEY, sessionId);
    return true;
  } catch {
    return false;
  }
}

export function clearPurchaseSession(storage) {
  try { storage.removeItem(KEY); } catch {}
}
